import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Guid } from 'guid-typescript';
import { PolicySummaryResponse } from 'src/app/api/models/policySummaryResponse.model';
import { PoliciesService } from 'src/app/api/services/policies.service';
import * as fromContext from 'src/app/core/state/context';
import * as fromPolicy from 'src/app/core/state/contract';
import * as fromRoot from '../../core/state/core.state';
import { CONFIRM_CONTRACT_PATH, ROOT_PATH } from '../constants/route.constants';
import { PolicyDocumentType } from 'src/app/api/models/policyDocumentType';
import { lastValueFrom, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolicySummaryService {
  constructor(
    private policyService: PoliciesService,
    private store: Store<fromRoot.State>,
    private router: Router
  ) {}

  public processPolicySummary(agreementId: string, contextId: string, email: string) {
    this.policyService
      .GetPolicySummary(
        Guid.parse(agreementId).toJSON().value,
        Guid.parse(contextId).toJSON().value,
        email
      )
      .subscribe(data => {
        this.dispatchPolicy(data);
        this.router.navigate([`${ROOT_PATH}${CONFIRM_CONTRACT_PATH}`]);
      });
  }

  private async dispatchPolicy(dataPolicy: PolicySummaryResponse) {
    const knownPolicyDocumentTypes = Object.values(PolicyDocumentType) as string[];
    this.store.dispatch(
      fromPolicy.patchContract({
        payload: {
          RefContrat: dataPolicy.reference,
          RefDocumentCP: dataPolicy.documents
            ?.find(doc => doc.documentTypeCode === PolicyDocumentType.CP)
            ?.documentId.toString(),
          RefDocumentFIC: dataPolicy.documents
            .find(doc => doc.documentTypeCode === PolicyDocumentType.FIC)
            ?.documentId.toString(),
          RefDocumentCG: dataPolicy.documents
            .find(doc => doc.documentTypeCode === PolicyDocumentType.CG)
            ?.documentId.toString(),
          RefDocumentMandatSEPA: dataPolicy.documents
            .find(doc => doc.documentTypeCode === PolicyDocumentType.SEPA)
            ?.documentId.toString(),
          RefOtherDocuments: [
            ...dataPolicy.documents.filter(
              doc => !knownPolicyDocumentTypes.includes(doc.documentTypeCode)
            )
          ],
          RefDocumentsSI: [
            ...dataPolicy.documents
              .filter(doc => doc.documentTypeCode === PolicyDocumentType.ATTSCO)
              .map(doc => doc.documentId.toString())
          ],
          RefDocumentAttestation: dataPolicy.documents
            .find(doc => doc.documentTypeCode === PolicyDocumentType.ATTASSU)
            ?.documentId.toString()
        }
      })
    );
    var contextData = await lastValueFrom(
      this.store.select(fromContext.selectContextData).pipe(take(1))
    );

    this.store.dispatch(
      fromContext.patchContextData({
        payload: {
          originalCanalVente: dataPolicy.salesChannel ?? contextData?.canalVente ?? ''
        }
      })
    );
  }
}
